import React, { useMemo, useState } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import HSButton from '../../../common/Button';
import { IoCheckmarkDone } from 'react-icons/io5';
import { MdOutlineWatchLater } from 'react-icons/md';
import Apis from '../../../../api';
import MessageActions from '../../../message/redux/actions';
import DealPaymentActions from '../redux/actions';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';

let infoArr = ['Remitting Account Name', 'Remitting Account Number', 'Amount Transferred'];

const PaymentUpload: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [downloadIndex, setDownloadIndex] = useState<string | undefined>(undefined);
    const investment = useSelector((state: RootState) => state.dealPayment.payment?.investment);
    const [loading, setLoading] = useState(false);

    const isPaymentReceipts = useMemo(() => {
        if (investment && investment.paymentReceipts && investment.paymentReceipts.length > 0) {
            return true;
        }
        return false;
    }, [investment]);

    const fileDownload = (title: string) => {
        if (investment?.uuid) {
            setDownloadIndex(title);
            Apis.downloadPaymentReceipt({
                documentType: 'PaymentReceipt',
                title,
            }, investment.uuid)
                .then((response) => {
                    try {
                        let file = new Blob([response.data], { type: response.headers['content-type'] });
                        let fileURL = window.URL.createObjectURL(file);
                        let a = document.createElement('a');
                        document.body.appendChild(a);
                        a.setAttribute('style', 'display: none');
                        a.href = fileURL;
                        a.download = title;
                        a.click();
                        window.URL.revokeObjectURL(fileURL);
                    } catch (err) {
                        dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                    }
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setDownloadIndex(undefined);
                });
        }
    };

    const redirectToInvestment = () => {
        return navigate(HEADERMENU_PATH.investments);
    };

    const fileUpload = (files: FileList | null) => {
        if (files && files[0] && investment?.uuid) {
            setLoading(true);
            let data = new FormData();
            data.set('entityId', investment.uuid);
            data.append('doc', files['0']);
            Apis.uploadPaymentReceipt(data, investment.uuid)
                .then(() => {
                    dispatch(
                        MessageActions.showMessage({ error: false, text: 'Payment receipt uploaded successfully' }),
                    );
                    dispatch(DealPaymentActions.getDealPaymentReq(investment?.uuid));
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto">
            <div className="px-4 py-4">
                <p className="text-xl SourceSansPro-SemiBold">Proof of Payment</p>
                {investment && isPaymentReceipts && (
                    <ul className="list-disc flex justify-center mt-4 flex-col">
                        {investment.paymentReceipts.map((r, index) => (
                            <li
                                key={`receipt_${index}_${r.title}`}
                                onClick={() => fileDownload(r.title)}
                                className="text-base text-blue-600 cursor-pointer flex items-center justify-center"
                            >
                                {`Payment Receipt ${index + 1}`}
                                {downloadIndex === r.title && <Loaderdownload />}
                            </li>
                        ))}
                    </ul>
                )}
                <div className="flex flex-col justify-center py-5 mt-4 md:flex-row">
                    <input
                        id="receipt"
                        type="file"
                        name="file-input"
                        style={{ display: 'none' }}
                        onChange={(e) => fileUpload(e.target.files)}
                    />
                    <HSButton
                        title={isPaymentReceipts ? 'Upload another receipt' : 'Upload receipt'}
                        light={isPaymentReceipts ? true : false}
                        className="mr-0 my-2 md:mr-4"
                        onClick={() => document.getElementById('receipt')?.click()}
                        icon={<AiOutlineCloudUpload />}
                        loading={loading}
                    />
                    <HSButton
                        title={isPaymentReceipts ? 'Done' : 'Pay Later'}
                        light={isPaymentReceipts ? false : true}
                        onClick={redirectToInvestment}
                        className="my-2"
                        icon={isPaymentReceipts ? <IoCheckmarkDone /> : <MdOutlineWatchLater />}
                    />
                </div>
                <div>
                    <p className="text-base pb-4 font-light">
                        The following details must be shown and clearly visible on the Proof of Payment:
                    </p>
                    <ul className="list-decimal pl-4">
                        {infoArr.map((i, index) => (
                            <li className="text-base font-light" style={{ color: '#16365C' }} key={`${index}_${i}`}>
                                {i}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PaymentUpload;

export const Loaderdownload = () => {
    return (
        <div
            style={{ borderTopColor: 'transparent' }}
            className="w-4 h-4 border-2 border-blue-400 border-solid rounded-full animate-spin"
        />
    );
};
